import {getAxios, Pageable} from '@deviceinsight/ng-ui-api-client';
import {OwnSubtenant, Subtenant} from '../modules/subtenants/types';
import '../modules/subtenants/types';

const getSubtenantById = (id: string): Promise<Subtenant> =>
	getAxios()
		.get(`/rafi/v1/subtenants/${id}`)
		.then((response) => response.data);

const getOwnSubtenant = (): Promise<OwnSubtenant> =>
	getAxios()
		.get(`/rafi/v1/subtenants/me`)
		.then((response) => response.data);

const listSubtenants = (): Promise<Pageable<Subtenant>> =>
	getAxios()
		.get('/rafi/v1/subtenants', {params: {size: 10000}})
		.then((response) => response.data);

export {getSubtenantById, getOwnSubtenant, listSubtenants};
